import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import { useQuery } from "@vue/apollo-composable";

import { TtPage } from "@/CodegenTypes";
import { times } from "lodash";

import { TT_MODE_NAMES } from "@/constants/index";
import { apolloClient, mutations, queries } from "@/apollo";
import { formatCount } from "@/helpers/formatCount";
import { formatDollar } from "@/helpers/formatDollar";
import { customMoment, vueApp } from "@/main";
import { errorMutationNotification } from "@/utils";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'TTPageDetailsModal',
  props: {
    value: { type: Boolean },
    pageId: null,
    releaseDates: null,
    showDelete: { type: Boolean }
  },
  emits: ["input", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  pageId?: TtPage["id"];
  releaseDates?: Date[];
  showDelete?: boolean;
};





const { $t } = useTranslation();
const t = (text: string) => $t(text);

const { result: ttPageResult, refetch } = useQuery<{ ttPage: TtPage }>(
  queries.ttPage,
  {
    id: computed(() => props.pageId),
    releaseDates: computed(() => props.releaseDates),
  },
  {
    enabled: computed(() => !!props.pageId),
    fetchPolicy: "cache-and-network",
  }
);

const ttPage = computed(() => ttPageResult.value?.ttPage ?? null);
const checkedEntries = ref<TtPage["id"][]>([]);
const startIndex = ref(0);
const PER_PAGE = 40;
const clickCounter = ref(0);

const rowsPerTable = computed(() => PER_PAGE / 2);
const totalEntriesCount = computed(() => ttPage.value?.entries.length);
const entriesInPage = computed(() => {
  const endIndex = startIndex.value + PER_PAGE;
  return ttPage.value?.entries.slice(startIndex.value, endIndex);
});

const entriesInFirstTable = computed(() => {
  if (!entriesInPage.value) {
    return [];
  }
  const dataRows = entriesInPage.value.slice(0, rowsPerTable.value);
  const rowsToPad = rowsPerTable.value - dataRows.length - 1;
  const padRows = [] as any[];
  times(rowsToPad, () => {
    padRows.push({ number: "", unit: "", mode: "", amount: "" });
  });
  return [...dataRows, ...padRows];
});

const entriesInSecondTable = computed(() => {
  if (!entriesInPage.value) {
    return [];
  }
  const dataRows = entriesInPage.value.slice(rowsPerTable.value);
  const rowsToPad = rowsPerTable.value - dataRows.length - 1;
  const padRows = [] as any[];
  times(rowsToPad, () => {
    padRows.push({ number: "", unit: "", mode: "", amount: "" });
  });
  return [...dataRows, ...padRows];
});

function formatDate(dateStr: string) {
  return customMoment(dateStr).format("ddd, DD/MM/YYYY hh:mm:ssA");
}

function toggleModal(val: boolean) {
  emit("input", val);
}

function convertModeValToName(val: string) {
  return (TT_MODE_NAMES as Record<string, string>)[val];
}

async function handleDelete() {
  vueApp.$confirm.require({
    header: 'Delete entry?',
    message: 'This action cannot be undone.',
    icon: 'pi pi-exclamation-triangle',
    accept: async () => {
      try {
        await apolloClient.mutate({
          mutation: mutations.deleteTtPageEntries,
          variables: {
            id: props.pageId,
            releaseDates: props.releaseDates,
            entryIds: checkedEntries.value
          },
        });
        refetch();
        
        vueApp.$toast.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Entries deleted',
          life: 3000
        });
        
        checkedEntries.value = [];
        emit("submit");
      } catch (err) {
        errorMutationNotification(err);
      }
    },
    reject: () => {
      // Optional: Handle rejection
    }
  });
}

watch(
  () => props.value,
  () => {
    startIndex.value = 0;
  }
);

return { __sfc: true,props, emit, $t, t, ttPageResult, refetch, ttPage, checkedEntries, startIndex, PER_PAGE, clickCounter, rowsPerTable, totalEntriesCount, entriesInPage, entriesInFirstTable, entriesInSecondTable, formatDate, toggleModal, convertModeValToName, handleDelete, formatCount, formatDollar }
}

})